import type { GuardAppEnvironment } from './types';

export const env: GuardAppEnvironment = {
  production: true,
  buildMode: 'ip4x',
  apiBaseUrl: 'https://ip4x-za.sudosky.com/v1',
  coreApiUrl: 'https://ip4x-core-api.sudosky.com/v1',
  guardAuthMode: 'auto',
  guardTenantId: '',
  defaultDomain: '',
  portalBaseUrl: 'https://guard.ip4x.systems',
  appName: 'Guard NOC',
  version: '1.0.0',
  panicPollIntervalMs: 8000,
  alarmSoundEnabled: true,
};
